import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
	FormGroup,
	FormControl,
	FormLabel,
	Col,
	Row,
	FormCheck,
} from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import moment from "moment";
import Layout from "components/Layout";
import SubmitButton from "components/SubmitButton";
import { iPlanService, appService } from "services";
// import { errorFormating } from "utils/utils";
import PlanNavigationTabs from "../components/Plans/PlanNavigationTabs";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
registerLocale("es", es);

import * as groupsActions from "actions/groupsActions";
import { showModal, hideModal, updateModalLoading } from "actions/modalActions";
import Modal from "components/Modal";



class Forecasting extends React.Component {
	constructor(props) {
		super(props);

		//console.log(props);
		this.state = {
			isLoading1: false,
			isLoading2: false,
			hasError1: false,
			hasError2: false,
			submitted1: false,
			submitted2: false,
			errors: {},
			selectedFile1: null,
			selectedFile2: null,
			weeklyHoursFilename: null,
			start: "",
			end: "",
			frequency: "HOURLY",
			operationalBase: "TOTAL_HOURS",
			alreadyCoveredPerHour: "",
			minimumNeeds: "",
			groupId: -1,
			staffingLevelId: -1,
			value: "",
			completado: false,
		};
		this.closeModal = this.closeModal.bind(this);
	}

	componentDidMount() {
		const { groups, getAllGroups, staffing_levels, getStaffingLevels } =
			this.props;

		if (!groups || groups.length === 0) {
			getAllGroups();
		}

		if (!staffing_levels || staffing_levels.length === 0) {
			getStaffingLevels();
		}
	}

	closeModal() {
		this.props.hideModal();
	}

	handleSwitch = (event) => {
		this.setState({
			[event.target.id]: event.target.checked,
		});
	};
	handleDateChange = (id, date) => {
		let key = id;
		let value = date ? moment(date).format("YYYY-MM-DD") : null;

		this.setState({
			[key]: value,
		});
	};

	// handleChange = (event) => {
	// 	const { id, name, value, files } = event.target;
	// 	const key = name || id;
	// 	// console.log(event);
	// 	// console.log(id);

	// 	this.setState({
	// 		[key]: files && files.length > 0 ? files[0] : value
	// 	});
	// };

	handleChange = (event) => {
		const { id, name, value, files } = event.target;
		const key = name || id;
		let newValue;
		if (files && files.length > 0) {
			newValue = files[0];
		} else if (key === "alreadyCoveredPerHour") {
			const parsed = parseInt(value, 10);
			newValue = isNaN(parsed) ? 0 : parsed;
		} else {
			newValue = value;
		}
		this.setState({ [key]: newValue });
	};

	handleChange = (event) => {
		const { id, name, value, files } = event.target;
		const key = name || id;
		let newValue;
		if (files && files.length > 0) {
			newValue = files[0];
		} else if (key === "alreadyCoveredPerHour" || key === "minimumNeeds") {
			// Permitimos valores vacíos o enteros
			if (value === "") {
				newValue = "";
			} else {
				const parsed = parseInt(value, 10);
				newValue = isNaN(parsed) ? "" : parsed;
			}
		} else {
			newValue = value;
		}
		this.setState({ [key]: newValue });
	};

	checkValidField = (name, submittedKey) => {
		if (!this.state[submittedKey]) return false; // Si no se ha enviado el formulario, no validamos.

		const value = this.state[name];

		return (
			value === undefined ||
			value === "" ||
			value === null ||
			value === -1 ||
			(name === "value" && (value === "0" || value === 0))
		);
	};

	openForecastDownloadModal(token) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("forecasting.modalTitle"),
				style: { width: "400px" },
				confirmText: this.props.t("forecasting.modalConfirm"),
				loadingText: this.props.t("forecasting.modalLoading"),
				message:
					this.props.t("forecasting.modalMessage"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, "forecast_ventas.xlsx");
				},
			},
			"confirm"
		);
	}

	async handleDownloadTemplate() {
		const response = await iPlanService.downloadSalesTemplate();

		const url = window.URL.createObjectURL(response);
		const a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = "sales_template.xlsx";
		a.click();
	}

	async downloadExport(token, filename) {
		const response = await appService.getExported(token);
		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = filename;
		a.click();
		this.props.updateModalLoading(false); // Cambiar a no cargando
		this.closeModal(); // cerrar modal de confirmación
	}

	handleForecasting = async (event) => {
		const { start, end, frequency, selectedFile1 } = this.state;
		event.preventDefault();
		this.setState({
			isLoading1: true,
			hasError1: false,
			hasError2: false,
		});

		if (selectedFile1) {
			var formData = new FormData();
			formData.append("filename", selectedFile1);
			formData.append("frequency", frequency); // frecuencia
			formData.append("start", start); // Fecha de inicio
			formData.append("end", end); // Fecha de fin
			// console.log(formData);
			const response = await iPlanService.salesForecast(formData);

			console.log(response);

			if (response.ok && !response.has_errors) {
				this.setState(
					{
						isLoading1: false,
						hasError1: false,
						errors: {},
					},
					() => {
						if (response.access_token) {
							this.openForecastDownloadModal(response.access_token);
						}
					}
				);
			} else if (!response.ok) {
				const messages = this.extractErrorMessages(response);

				this.setState({
					isLoading1: false,
					hasError1: true,
					submitted1: true,
					errors: {
						message:
							messages.length > 0
								? this.props.t("forecasting.errorCount", { count: messages.length })
								: this.props.t("forecasting.errorGeneric"),
						details: messages,
					},
				});
			} else {
				this.setState({
					isLoading1: false,
					hasError1: true,
					submitted1: true,
					errors: response.rows.length > 0 ? {} : response.errors[0],
				});
			}
		} else {
			this.setState({
				isLoading1: false,
				submitted1: true,
			});
		}
	};

	extractErrorMessages = (resp) =>
		Array.isArray(resp?.errors)
			? resp.errors
					.map(
						(e, i) => e?.value || e?.description || e?.code || `Error #${i + 1}`
					)
					.filter(Boolean)
			: [];

	handleForecastingNeeds = async (event) => {
		event.preventDefault();
		const {
			value,
			groupId,
			frequency,
			operationalBase,
			alreadyCoveredPerHour,
			minimumNeeds,
			staffingLevelId,
			selectedFile2,
			weeklyHoursFilename,
		} = this.state;

		this.setState({
			isLoading2: true,
			hasError1: false,
			hasError2: false,
		});

		// console.log("weeklyHoursFilename", weeklyHoursFilename);

		if (selectedFile2) {
			var formData = new FormData();
			formData.append("filename", selectedFile2);
			formData.append("frequency", frequency);
			formData.append("operationalBase", operationalBase);
			if (operationalBase === "TOTAL_HOURS") {
				formData.append("alreadyCoveredPerHour", alreadyCoveredPerHour || 0);
				formData.append("minimumNeeds", minimumNeeds || 0);
			}
			if (weeklyHoursFilename) {
				formData.append("weeklyHoursFilename", weeklyHoursFilename);
			}
			formData.append("value", value);
			formData.append("groupId", groupId);
			formData.append("staffingLevelId", staffingLevelId);
			const response = await iPlanService.staffingLevelsForecast(formData);
			console.log(response);

			if (response.ok && !response.has_errors) {
				this.setState(
					{
						isLoading2: false,
						hasError2: false,
						errors: {},
						completado: true,
					},
					() => {
						// TODO hacer algo
					}
				);
			} else if (!response.ok) {
				const messages = this.extractErrorMessages(response);

				this.setState({
					isLoading2: false,
					hasError2: true,
					submitted2: true,
					errors: {
						message:
							messages.length > 0
								? this.props.t("forecasting.errorCount", { count: messages.length })
								: this.props.t("forecasting.errorGeneric"),
						details: messages, // <-- aquí tendrás la lista (fila/columna…)
					},
				});
			} else {
				const messages = this.extractErrorMessages(response);
				this.setState({
					isLoading2: false,
					hasError2: true,
					submitted2: true,
					errors:
						response.rows?.length > 0
							? {}
							: messages.length > 0
								? {
										message: this.props.t("forecasting.errorCount", { count: messages.length }),
										details: messages,
									}
								: response.errors?.[0] || {
										message: this.props.t("forecasting.errorGeneric"),
									},
				});
			}
		} else {
			this.setState({
				isLoading2: false,
				submitted2: true,
			});
		}
	};

	getForecastingContent = () => {
		const { start, end, frequency } = this.state;

		return (
			<form onSubmit={this.handleForecasting}>
				<div className="mt10 mb25">
					{this.props.t("forecasting.downloadTemplate1")}{" "}
					<span className="link" onClick={() => this.handleDownloadTemplate()}>
						{this.props.t("forecasting.downloadTemplateLink")}
					</span>{" "}
					{this.props.t("forecasting.downloadTemplate2")}
				</div>
				<FormGroup className="form-group" controlId="selectedFile1">
					<FormLabel>
						{this.props.t("forecasting.labelSalesFile")}{" "}
						<span className="label-required">*</span>
					</FormLabel>

					<FormControl
						type="file"
						onChange={this.handleChange}
						className="form-control"
						isInvalid={this.checkValidField("selectedFile1", "submitted1")}
					/>
					<FormControl.Feedback type="invalid">
						{this.props.t("forecasting.feedbackSalesFile")}
					</FormControl.Feedback>
				</FormGroup>

				<Row className="row-fechas">
					<Col sm={6} md={4}>
						<FormGroup
							controlId="start"
							className={`form-group form-date ${start === "" && "empty"}  ${this.checkValidField("start", "submitted1") && "is-invalid"}`}
						>
							<FormLabel>
								{this.props.t("forecasting.labelStart")} <span className="label-required">*</span>
							</FormLabel>
							<DatePicker
								selected={
									start === "" || !start ? null : moment(start).toDate()
								}
								onChange={(date) => this.handleDateChange("start", date)}
								isInvalid={this.checkValidField("start", "submitted1")}
								className="form-control"
								dateFormat="dd/MM/yyyy"
								locale="es"
								placeholderText="dd/mm/aaaa"
							/>
							<FiCalendar />
							<FormControl.Feedback type="invalid">
								{this.props.t("forecasting.feedbackStart")}
							</FormControl.Feedback>
						</FormGroup>
					</Col>

					<Col sm={6} md={4}>
						<FormGroup
							controlId="end"
							className={`form-group form-date ${end === "" && "empty"}  ${this.checkValidField("end", "submitted1") && "is-invalid"}`}
						>
							<FormLabel>
								{this.props.t("forecasting.labelEnd")} <span className="label-required">*</span>
							</FormLabel>
							<DatePicker
								selected={end === "" || !end ? end : moment(end).toDate()}
								onChange={(date) => this.handleDateChange("end", date)}
								isInvalid={this.checkValidField("end", "submitted1")}
								className="form-control"
								dateFormat="dd/MM/yyyy"
								locale="es"
								placeholderText="dd/mm/aaaa"
							/>
							<FiCalendar />
							<FormControl.Feedback type="invalid">
								{this.props.t("forecasting.feedbackEnd")}
							</FormControl.Feedback>
						</FormGroup>
					</Col>

					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="frequency">
							<FormLabel>
								{this.props.t("forecasting.labelFrequency")} <span className="label-required">*</span>
							</FormLabel>
							<div className="btn-choice-group">
								<FormCheck
									type="radio"
									id="frequency_HOURLY"
									name="frequency"
									label={this.props.t("forecasting.freqHourly")}
									value="HOURLY"
									checked={frequency === "HOURLY"}
									bsPrefix={
										frequency === "HOURLY" ? "btn-choice active" : "btn-choice"
									}
									onChange={this.handleChange}
								/>
								<FormCheck
									type="radio"
									id="frequency_HALF_HOUR"
									name="frequency"
									label={this.props.t("forecasting.freqHalfHour")}
									value="HALF_HOUR"
									checked={frequency === "HALF_HOUR"}
									bsPrefix={
										frequency === "HALF_HOUR"
											? "btn-choice active"
											: "btn-choice"
									}
									onChange={this.handleChange}
								/>
							</div>
						</FormGroup>
					</Col>
				</Row>

				<SubmitButton
					type="submit"
					isLoading={this.state.isLoading1}
					text={this.props.t("forecasting.btnCalculate")}
					loadingText={this.props.t("forecasting.btnCalculating")}
				/>
			</form>
		);
	};

	getNeedsContent = () => {
		const {
			frequency,
			operationalBase,
			alreadyCoveredPerHour,
			minimumNeeds,
			value,
			staffingLevelId,
			groupId,
			completado,
		} = this.state;
		const { groups, staffing_levels } = this.props;
		const optionGroupList = groups.map((item, i) => (
			<option key={i} value={item.id}>
				{item.name}
			</option>
		));
		const optionStaffingLevelsList = staffing_levels.map((item, i) => (
			<option key={i} value={item.id}>
				{item.name}
			</option>
		));

		return (
			<form onSubmit={this.handleForecastingNeeds}>
				<FormGroup className="form-group" controlId="selectedFile2">
					<FormLabel>
						{this.props.t("forecasting.labelForecastFile")}{" "}
						<span className="label-required">*</span>
					</FormLabel>

					<FormControl
						type="file"
						onChange={this.handleChange}
						className="form-control"
						isInvalid={this.checkValidField("selectedFile2", "submitted2")}
					/>
					<FormControl.Feedback type="invalid">
						{this.props.t("forecasting.feedbackForecastFile")}
					</FormControl.Feedback>
				</FormGroup>

				<Row>
					<Col sm={6}>
						<FormGroup className="form-group" controlId="frequency2">
							<FormLabel>
								{this.props.t("forecasting.labelFrequencyDetail")}{" "}
								<span className="label-required">*</span>
							</FormLabel>
							<div className="btn-choice-group">
								<FormCheck
									type="radio"
									id="frequency_HOURLY"
									name="frequency"
									label={this.props.t("forecasting.freqHourly")}
									value="HOURLY"
									checked={frequency === "HOURLY"}
									bsPrefix={
										frequency === "HOURLY" ? "btn-choice active" : "btn-choice"
									}
									onChange={this.handleChange}
								/>
								<FormCheck
									type="radio"
									id="frequency_HALF_HOUR"
									name="frequency"
									label={this.props.t("forecasting.freqHalfHour")}
									value="HALF_HOUR"
									checked={frequency === "HALF_HOUR"}
									bsPrefix={
										frequency === "HALF_HOUR"
											? "btn-choice active"
											: "btn-choice"
									}
									onChange={this.handleChange}
								/>
							</div>
						</FormGroup>
					</Col>
					{operationalBase === "TOTAL_HOURS" && (
						<Col sm={6}>
							<FormGroup className="form-group" controlId="weeklyHoursFilename">
								<FormLabel>
									{this.props.t("forecasting.labelWeeklyHours")}
								</FormLabel>

								<FormControl
									type="file"
									onChange={this.handleChange}
									className="form-control"
								/>
							</FormGroup>
						</Col>
					)}
				</Row>
				<Row>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="operationalBase">
							<FormLabel>
								{this.props.t("forecasting.labelOperationalBase")}{" "}
								<span className="label-required">*</span>
							</FormLabel>
							<FormControl
								as="select"
								value={operationalBase}
								onChange={this.handleChange}
							>
								<option value="TOTAL_HOURS">{this.props.t("forecasting.baseRuleHours")}</option>
								<option value="FTE">{this.props.t("forecasting.baseRuleFTE")}</option>
							</FormControl>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="value">
							<FormLabel>
								{this.props.t("forecasting.labelValue")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={value.toString().replace(".", ",")}
								onChange={this.handleChange}
								placeholder="0"
								isInvalid={this.checkValidField("value", "submitted2")}
							/>
							<FormControl.Feedback type="invalid">
								{this.props.t("forecasting.feedbackValue")}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="groupId">
							<FormLabel>
								{this.props.t("forecasting.labelGroup")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								as="select"
								value={groupId}
								onChange={this.handleChange}
								isInvalid={this.checkValidField("groupId", "submitted2")}
							>
								<option value="-1">{this.props.t("forecasting.selectGroup")}</option>
								{optionGroupList}
							</FormControl>
							<FormControl.Feedback type="invalid">
								{this.props.t("forecasting.feedbackGroup")}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="staffingLevelId">
							<FormLabel>
								{this.props.t("forecasting.labelStaffingLevel")}{" "}
								<span className="label-required">*</span>
							</FormLabel>
							<FormControl
								onChange={this.handleChange}
								value={staffingLevelId}
								isInvalid={this.checkValidField(
									"staffingLevelId",
									"submitted2"
								)}
								as="select"
							>
								<option value="-1">{this.props.t("forecasting.selectStaffingLevel")}</option>
								{optionStaffingLevelsList}
							</FormControl>

							<FormControl.Feedback type="invalid">
								{this.props.t("forecasting.feedbackStaffingLevel")}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					{operationalBase === "TOTAL_HOURS" && (
						<>
							<Col sm={6} md={4}>
								<FormGroup
									className="form-group"
									controlId="alreadyCoveredPerHour"
								>
									<FormLabel>{this.props.t("forecasting.labelAlreadyCovered")}</FormLabel>
									<FormControl
										type="number"
										min={0}
										step={1}
										value={alreadyCoveredPerHour}
										onChange={this.handleChange}
										placeholder="0"
									/>
								</FormGroup>
							</Col>
							<Col sm={6} md={4}>
								<FormGroup className="form-group" controlId="minimumNeeds">
									<FormLabel>
										{this.props.t("forecasting.labelMinimumNeeds")}
									</FormLabel>
									<FormControl
										type="number"
										min={0}
										step={1}
										value={minimumNeeds}
										onChange={this.handleChange}
										placeholder="0"
									/>
								</FormGroup>
							</Col>
						</>
					)}
				</Row>
				<SubmitButton
					type="submit"
					isLoading={this.state.isLoading2}
					text={this.props.t("forecasting.btnUpdate")}
					loadingText={this.props.t("forecasting.btnUpdating")}
				/>
				{completado && (
					<div className="alert alert-success mt10">
						<p className="alert-intro">
							{this.props.t("forecasting.successUpdate")}
						</p>
					</div>
				)}
			</form>
		);
	};

	getErrorsContent = () => {
		const { errors } = this.state;

		return (
			<div className="error-box">
				{errors.message && <p className="error-message">{errors.message}</p>}

				{errors?.details?.length > 0 && (
					<ul className="list-error">
						{errors.details.map((m, i) => (
							<li key={i}>{m}</li>
						))}
					</ul>
				)}
			</div>
		);
	};

	render() {
		const { hasError1, hasError2 } = this.state;

		return (
			<>
				<Layout className="page-imports">
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{this.props.t("forecasting.title")}</h1>
						</div>
					</div>

					<PlanNavigationTabs />

					<h2 className="subtitle">{this.props.t("forecasting.subtitle1")}</h2>
					<div className="alert alert-info">
						<p className="mb5">
							{this.props.t("forecasting.infoIntro")}
						</p>
						<ul className="lista">
							<li>{this.props.t("forecasting.infoDay")}</li>
							<li>{this.props.t("forecasting.infoHour")}</li>
							<li>{this.props.t("forecasting.infoMinute")}</li>
							<li>{this.props.t("forecasting.infoValue")}</li>
						</ul>
					</div>

					{this.getForecastingContent()}

					{hasError1 && this.getErrorsContent()}

					<hr className="mb30" />

					<h2 className="subtitle">
						{this.props.t("forecasting.subtitle2")}
					</h2>

					<p>
						{this.props.t("forecasting.needsIntro")}
					</p>

					{this.getNeedsContent()}

					{hasError2 && this.getErrorsContent()}
				</Layout>
				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => ({
	...reducers.groupsReducer,
	loading: reducers.plansReducer.loading,
});

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
	getAllGroups: () => dispatch(groupsActions.getAllGroups()),
	getStaffingLevels: (q) => dispatch(groupsActions.getAllStaffingLevels(q)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Forecasting));
